/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-named-as-default-member */
import dayjs from 'dayjs'

import { AccessType } from 'API'
import { listEventsForParticipantUpdate } from 'api/queries'
import { ACCESS_TYPES, EVENT_SHIRT_DETAILS } from 'constants/models'
import { Event } from 'models/API'
import { jsonParse } from 'utils/ObjectUtil'

import { usePaginatedEvents } from './usePaginatedEvents'

const queryInfo = [
  {
    options: { filter: { endDateTime: { gt: dayjs().tz('Asia/Manila') } } },
    name: 'listEvents',
    query: listEventsForParticipantUpdate,
    isFP: false,
  },
]

const parseItem = (item: any): Event => ({
  ...item,
  accessType: (item.accessType ?? ACCESS_TYPES.PUBLIC) as AccessType,
  ...(item.subCategories && {
    subCategories: JSON.parse(JSON.parse(item.subCategories as string)),
  }),
  shirtDetails: {
    ...EVENT_SHIRT_DETAILS,
    ...(item.shirtDetails && {
      ...JSON.parse(JSON.parse(item.shirtDetails as string)),
    }),
  },
  waiver: jsonParse(jsonParse(item.waiver as string)),
})

export const useListEventsForParticipantUpdate = () => {
  const { items: events, apiLoading, apiError } = usePaginatedEvents<Event>(queryInfo, parseItem)
  return { events, apiLoading, apiError }
}
